//#region src/kiosk_notification_type.ts
var KioskNotificationType = /* @__PURE__ */ function(KioskNotificationType) {
	KioskNotificationType[KioskNotificationType["RestartApp"] = 1] = "RestartApp";
	KioskNotificationType[KioskNotificationType["RequestLogs"] = 2] = "RequestLogs";
	KioskNotificationType[KioskNotificationType["RequestScreenshot"] = 3] = "RequestScreenshot";
	KioskNotificationType[KioskNotificationType["UpdatePaymentTerminal"] = 4] = "UpdatePaymentTerminal";
	KioskNotificationType[KioskNotificationType["EnableAsam"] = 5] = "EnableAsam";
	KioskNotificationType[KioskNotificationType["DisableAsam"] = 6] = "DisableAsam";
	KioskNotificationType[KioskNotificationType["RequestStatus"] = 7] = "RequestStatus";
	KioskNotificationType[KioskNotificationType["KioskUpdate"] = 8] = "KioskUpdate";
	KioskNotificationType[KioskNotificationType["ConfigUpdate"] = 9] = "ConfigUpdate";
	KioskNotificationType[KioskNotificationType["TestPrint"] = 10] = "TestPrint";
	KioskNotificationType[KioskNotificationType["MenuUpdate"] = 11] = "MenuUpdate";
	KioskNotificationType[KioskNotificationType["UploadPaymentTerminalLogs"] = 15] = "UploadPaymentTerminalLogs";
	KioskNotificationType[KioskNotificationType["RunWhitelistTest"] = 16] = "RunWhitelistTest";
	KioskNotificationType[KioskNotificationType["PaymentTerminalStatusUpdate"] = 17] = "PaymentTerminalStatusUpdate";
	KioskNotificationType[KioskNotificationType["AppUpdate"] = 18] = "AppUpdate";
	KioskNotificationType[KioskNotificationType["AppLogout"] = 20] = "AppLogout";
	KioskNotificationType[KioskNotificationType["RefundRequest"] = 21] = "RefundRequest";
	KioskNotificationType[KioskNotificationType["MenuUpdateNoChange"] = 22] = "MenuUpdateNoChange";
	KioskNotificationType[KioskNotificationType["RunSpeedTest"] = 23] = "RunSpeedTest";
	KioskNotificationType[KioskNotificationType["AppLogin"] = 24] = "AppLogin";
	KioskNotificationType[KioskNotificationType["BuildUpdateVitrine"] = 25] = "BuildUpdateVitrine";
	KioskNotificationType[KioskNotificationType["BuildUpdateGarcon"] = 26] = "BuildUpdateGarcon";
	KioskNotificationType[KioskNotificationType["BuildUpdateChromeOs"] = 27] = "BuildUpdateChromeOs";
	KioskNotificationType[KioskNotificationType["RebootPaymentTerminal"] = 28] = "RebootPaymentTerminal";
	KioskNotificationType[KioskNotificationType["ReturnToConfig"] = 29] = "ReturnToConfig";
	KioskNotificationType[KioskNotificationType["LiveViewClick"] = 30] = "LiveViewClick";
	KioskNotificationType[KioskNotificationType["LiveViewScroll"] = 31] = "LiveViewScroll";
	return KioskNotificationType;
}(KioskNotificationType || {});
//#endregion
export { KioskNotificationType };

//# sourceMappingURL=kiosk_notification_type.js.map